import { v4 as uuid } from 'uuid';

export const saveToStorage = (data) => {
    const { dno } = data;
    const storage = window.localStorage;
    if (hasData(dno)) return;
    storage.setItem(dno, JSON.stringify(data))
}

const setId = () => {
    const storage = window.localStorage;
    const uid = `${uuid()}-${Date.now()}`;
    storage.setItem('myFavorite_id', uid);
}

export const hasData = (dno) => {
    const storage = window.localStorage;
    return storage.getItem(dno) ? true : false;
}

export const getAllKeys = () => {
    const storage = window.localStorage;
    if (!hasData('myFavorite_id')) {
        setId();
    }
    const allKeys = [];
    for (let i = 0; i < storage.length; i++) {
        if (/^\d{4,6}$/.test(storage.key(i))) {
            allKeys.push(storage.key(i));
        }
    }
    return allKeys;
}

export const getDataByKey = (key) => {
    const storage = window.localStorage;
    return JSON.parse(storage.getItem(key)) || {};
}

export const removeDataByKey = (key) => {
    const storage = window.localStorage;
    return storage.removeItem(key);
}

export const setLanguage = (language) => {
    const storage = window.localStorage;
    storage.setItem('language', language);
}

export const getLanguage = () => {
    const storage = window.localStorage;
    return storage.getItem('language');
}

export const setCookieAccepted = () => {
    const storage = window.localStorage;
    storage.setItem('cookieAccepted', true);
}

export const getCookieAccepted = () => {
    const storage = window.localStorage;
    return storage.getItem('cookieAccepted');
}